"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BOMShareButton_1 = __importDefault(require("./BOMShareButton"));
exports.default = BOMShareButton_1.default;
